import { TimeEntry } from '../../../api/generated/data-contracts';
import { validationRules } from '../../validationRules';
import { ValidateResponse } from '../../Validator';

interface MinPercentPerDayProps {
    timeEntries: TimeEntry[];
    [key: string]: any;
    userCapacity: number;
}

export const MinPercentPerDay = (props: MinPercentPerDayProps): ValidateResponse => {
    const minPercent = props.config.timeSheetValidation.minPercentPerDay || 5;

    const availability = props.userCapacity;

    const minHoursAsPercent = (availability / 100) * minPercent;
    const entries = props.timeEntries.filter(te => te.hours !== 0).filter(te => te.hours < minHoursAsPercent);

    const valid = entries.length === 0;

    const response: ValidateResponse = {
        reason: !valid ? `You have to report more than ${minPercent}% per period` : null,
        valid: valid,
        name: validationRules.minPercentPerDayEnabled,
        rejected: !valid,
    };

    return response;
};
